import { FeatureSet } from "./features";

class Config {
  getMagentoUrl() {
    if (FeatureSet.enableMagentoMcProd()) {
      return MAGENTO_MCPROD;
    }
    if (FeatureSet.enableMagentoStaging1()) {
      return MAGENTO_MCSTAGING1;
    }
    if (FeatureSet.enableMagentoStaging2()) {
      return MAGENTO_MCSTAGING2;
    }
    if (FeatureSet.enableMagentoStaging4()) {
      return MAGENTO_MCSTAGING4;
    }
    if (FeatureSet.enableMagentoStaging5()) {
      return MAGENTO_MCSTAGING5;
    }
    return MAGENTO_ENDPOINT;
  }

  isSanityPromoBarEnabled() {
    return ENABLE_SANITY_PROMO_BAR === "true" || FeatureSet.enableSanityPromoBar();
  }

  getSanityProjectId() {
    return SANITY_PROJECT_ID;
  }

  getSanityDataset() {
    return SANITY_DATASET;
  }
}

export default new Config();
